(function(window, document, $, undefined){
  
    var scrollDeadZone = 0;

  
    var hasShown = false;

    var goToTopScroll = function(){
      if ($(this).scrollTop() > scrollDeadZone) {
        // show
        if(!hasShown) {
          $('.scrollmore').fadeOut(300);
          $('body').addClass('scrolled');
        }
        hasShown = true;
        
      } else {
        // hide
        if(hasShown) {
          $('.scrollmore').fadeIn(300);
          $('body').removeClass('scrolled');
        }
        hasShown = false;
      }
    };
    $(window).on("scroll", goToTopScroll);

    goToTopScroll();




    var resizeHandler = debounce(function(){
      positionScrollmore();
    },100);
    $(window).on("resize", resizeHandler);

    function positionScrollmore(){
      if(!$('.page-header').length) return false;
      var $el = $('.page-header');
      var cookieHeight = 0;
      if($('body').hasClass('cookie-consent')){
        cookieHeight = $('#cookie-consent').outerHeight(true);
      }
      var bottom = $el.position().top + $el.outerHeight(true) + cookieHeight;
      if(bottom > getHeight()){
        $('.scrollmore').addClass('fixed');
      } else {
        $('.scrollmore').removeClass('fixed');
      }
    }
    positionScrollmore();






    // goToTopScrollResize();

    // $(window).scroll(function() {
    //   if ($(this).scrollTop() > 200) {
    //     $('.go-to-top').fadeIn(300);
    //   } else {
    //     $('.go-to-top').fadeOut(200);
    //   }
    // });
    // $(window).on("scroll", goToTopScroll);

    function getWidth(){
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      return w;
    }
    function getHeight(){
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      return h;
    }
    // Animate the scroll to top
    $('.scrollmore').click(function(event) {
      event.preventDefault();
      // var sliderHeight = $('.page-header').outerHeight();
      // TweenMax.to($('html, body'),1,{scrollTop:sliderHeight,ease:Power2.easeInOut});
      var contentOffset = $('main.container').offset();
      contentOffset = contentOffset.top;
      if(getWidth()<768) contentOffset -= $('.site-header').height();
      console.log(contentOffset);
      TweenMax.to($('html, body'),1,{scrollTop:contentOffset,ease:Power3.easeInOut});
    });





})(window, document, jQuery);
